/**
 * Extract a readable filename from a URL, with fallback.
 */
const extractFilename = (url: string, fallback: string = 'download'): string => {
  try {
    const pathname = new URL(url).pathname;
    const segments = pathname.split('/');
    const last = segments[segments.length - 1];
    if (last && last.includes('.')) return decodeURIComponent(last);
  } catch {
    // not a valid URL
  }
  return fallback;
};

/**
 * Download a file by fetching it and triggering a browser save dialog.
 * Works cross-origin (Cloudinary, S3, etc.) and avoids Safari's issues
 * with `<a href target="_blank">` for PDF/document files.
 */
export const downloadFile = async (url: string, filename?: string): Promise<void> => {
  if (!url) {
    alert('No file available to download.');
    return;
  }

  // Invalid blob URLs from a previous session can't be downloaded
  if (url.startsWith('blob:')) {
    alert('This file was not uploaded correctly and cannot be downloaded. The applicant may need to re-upload it.');
    return;
  }

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Download failed (${response.status})`);

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename || extractFilename(url, 'document');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error('Download failed:', err);
    // Fallback: try opening directly in a new tab
    window.open(url, '_blank');
  }
};
